import FlagIcon from "@mui/icons-material/Flag";
import { DialogActions, DialogContent } from "@mui/material";
import {
  Button,
  Checkbox,
  CreatedUpdatedBy,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
  TextField,
} from "common";
import { ParamsContext } from "common/components/Form/ParamsContext";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import { createContext } from "react";
import useRedflagPartnerForm, {
  UseRedflagPartnerFormProps,
  UseRedflagPartnerFormReturnType,
} from "./useRedflagPartnerForm";
export const RedflagPartnerContext = createContext<
  UseRedflagPartnerFormReturnType | undefined
>(undefined);
export interface RedflagPartnerFormProps extends UseRedflagPartnerFormProps {}

export default function RedflagPartnerForm({
  id,
  afterSave,
  onClose,
  defaultValues,
}: RedflagPartnerFormProps) {
  const { hasPermissions, canEditItem } = useAccess();
  const form = useRedflagPartnerForm({
    id,
    afterSave,
    defaultValues,
  });
  const {
    params,
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    isUpdate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = form;
  const title = isCreate ? I18n.t("RedflagPartner.addTitle") : item.name;
  return (
    <ParamsContext.Provider value={{}}>
      <RedflagPartnerContext.Provider value={form}>
        <PageHeader
          avatar={<FlagIcon color="error" />}
          title={title}
          onClose={onClose}
          loading={loading}
        />
        <DialogContent>
          <Form
            loading={loading}
            item={item}
            options={options}
            errors={errors}
            onChange={onChange}
            translationCategory="RedflagPartner.attributes"
            isDirty={getIsDirty}
            requiredFields={getRequiredFields()}
            disabled={!canEditItem("partner_group", item)}
          >
            <FieldsContainer>
              <Field fullWidth>
                <TextField id="name" />
              </Field>
              <Field fullWidth>
                <TextField id="reason" />
              </Field>
              <Field fullWidth>
                <Checkbox id="active" />
              </Field>
            </FieldsContainer>
          </Form>
        </DialogContent>
        <DialogActions>
          {isUpdate && (
            <CreatedUpdatedBy
              objectName="RedflagPartner"
              item={item}
              sx={{
                p: 1,
                paddingTop: 0,
                paddingBottom: 0.5,
                marginRight: "auto",
              }}
            />
          )}
          <Button
            title={I18n.t("App.save")}
            disabled={!isDirty}
            onClick={() => save()}
            loading={saving}
          />
        </DialogActions>
      </RedflagPartnerContext.Provider>
    </ParamsContext.Provider>
  );
}
